import React, { lazy } from 'react';
export function VideoPlayer() {
  return <div className="aspect-video w-full bg-dark-700 rounded-lg overflow-hidden shadow-xl border border-dark-500" data-id="element-384">
      <div style={{
      position: 'relative',
      paddingTop: '56.25%'
    }} data-id="element-385">
        <iframe src="https://iframe.mediadelivery.net/embed/460652/9036721e-da9d-4190-bce4-2d453d9b1499?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
        border: 0,
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '100%'
      }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-386"></iframe>
      </div>
    </div>;
}